import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
} from '@material-ui/core';
import { resendInviteTeamMember } from '../../services/Agent';
import SnackbarMessage from '../SnackbarMessage';

const ResendInviteTeamMember = ({ agentId, closeModel, onSuccess }) => {
  const [processing, setProcessing] = useState(false);
  const [snackbarMeesage, setSnackbarMeesage] = useState({
    show: false,
    type: '',
    message: '',
  });

  const handleDialog = () => {
    closeModel();
  };

  const handleConfirmation = (e) => {
    e.preventDefault();
    setProcessing(true);
    resendInviteTeamMember(agentId)
      .then(() => {
        onSuccess();
      })
      .catch(() => {
        setSnackbarMeesage({
          ...snackbarMeesage,
          message: 'Some error occurred while deleting state, please try again.',
          type: 'error',
          show: 'error',
        });
        setProcessing(false);
      });
  };

  return (
    <Dialog open onClose={handleDialog}>
      <DialogTitle id="alert-dialog-title">Resend Team Member Invitation</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Do you want to resend the invitation to team member?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleConfirmation}
          color="secondary"
          autoFocus
          endIcon={processing && <CircularProgress size={25} />}
          disabled={processing}
        >
          Yes
        </Button>
        <Button onClick={handleDialog} color="primary">
          No
        </Button>
      </DialogActions>
      {snackbarMeesage.show && <SnackbarMessage {...snackbarMeesage} />}
    </Dialog>
  );
};

ResendInviteTeamMember.propTypes = {
  closeModel: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  agentId: PropTypes.number.isRequired,
};

export default ResendInviteTeamMember;
